
export enum ShipmentAcquiredTypeCd {
	DOCK_DROP = 'DockDrop',
	HOOK_LD = 'HookLd',
	REGULAR_PKUP = 'RegularPkup'}

